import { TextField } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'; 
import { Icon } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import './toast.css';
import Alert from '@mui/material/Alert';


toast.configure({
    autoClose:6000,
     draggable: true,
     hideProgressBar: true,
     position: toast.POSITION.BOTTOM_LEFT,
     
       
  });


function ValidationUIComponent(props){
    
    let value=props.value
    let onChange=props.onChanged
    let data=props.data
    let column=props.column;
    let validator = props.validator;
    let message = props.message;
    let placeholder = props.placeholder
    let adornment=props.adornment;



    var onFocusLost=async(event)=> {

        let inpValue= event.target.value;
        if (!inpValue || !inpValue.trim()) {
            console.log("empty value entered")
          return;
        }
        if (validator){
            console.log("validator is not empty")
            if(!validator(inpValue)) {
                console.log("wrong format of data entered")
                  toast.error(<Alert severity="error">{column.label+message}</Alert>,{
                    closeOnClick: true,
                    autoClose: true,
                    closeButton: true,
                    newestOnTop: true,
                  });
                  return;
            }
        }
        console.log("onFocusLost",inpValue);
       
        
      }

      const handleChange = (event) => {
        let newValue = event.target.value;
        // console.log(newValue);
        onChange({ ...data, [column.field]: newValue });

      };


    return (
        
        <TextField id="standard-basic" value={value} onBlur={onFocusLost} autoComplete="off"  onChange={handleChange} placeholder={placeholder} InputProps={{
          startAdornment: <InputAdornment position="start">{adornment}</InputAdornment>,
        }}/>
        
      )
}

export default ValidationUIComponent;